import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-referees-container',
  templateUrl: './referees-container.component.html',
  styleUrls: ['./referees-container.component.scss']
})
export class RefereesContainerComponent implements OnInit {
  public isLoading: boolean = false;
  refereeList?;
  @ViewChild('addNewRefereeModal', {static: false}) public addNewRefereeModal: ModalDirective;
  @ViewChild('removeRefereeModal', {static: false}) public removeRefereeModal: ModalDirective;


  refereeDetails:FormGroup
  constructor(private fb: FormBuilder) {
    this.refereeList=[{id:'temp',name:"temp name"}]
  }

  ngOnInit(): void {
    this.createForm();
  }

  createForm(): void {
    this.refereeDetails = this.fb.group({
      // countryCode: ['', Validators.required],
      countryCode: ['', [Validators.required, Validators.pattern(/^\+\d{1,4}$/)]],
      mobileNumber: ['',[Validators.required, Validators.pattern(/^\d+$/)]],      
    });
  }





  addReferee=()=>{
    this.createForm();
    this.addNewRefereeModal.show();

  }



  onSubmit(): void {

    if (this.refereeDetails.valid) {

      console.log(this.refereeDetails);
      this.refereeList=[...this.refereeList,{id:'temp',name:"temp Referee"}]
    this.addNewRefereeModal.hide();

    } else {
      // Form is invalid, show error messages
      this.markFormGroupTouched(this.refereeDetails);
    }
  }

  
  markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();

      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }

removeReferee=()=>{
  this.removeRefereeModal.hide();
}


}
